import { render, staticRenderFns } from "./Sterilizer.vue?vue&type=template&id=549a1ee7&scoped=true&"
import script from "./Sterilizer.vue?vue&type=script&lang=js&"
export * from "./Sterilizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a1ee7",
  null
  
)

export default component.exports